import { JsonLd } from "react-schemaorg"
import type { Event } from "schema-dts"

import { DateTime } from "@bounce/date"

import { useCityUrl } from "../../../libs/router"
import { useCityPriceInterpolations } from "../../../screens/LuggageStorage/CityScreen/hooks/useCityPriceInterpolations"
import type { CityData } from "@/libs/bounce/cities"
import type { FormattedEvent } from "@/libs/prismic/types"

type EventStructuredDataProps = {
  city: CityData
  event: FormattedEvent
}

export const EventStructuredData = ({ event, city }: EventStructuredDataProps) => {
  const { absolutePath } = useCityUrl({ city })
  const priceInterpolations = useCityPriceInterpolations(city)
  const optionalFields = {
    ...(event.startDate ? { startDate: event.startDate } : {}),
    ...(event.endDate ? { endDate: event.endDate } : {}),
    ...(event.image?.url ? { image: [event.image.url] } : {}),
    ...(event.excerpt.length > 0 ? { description: event.excerpt } : {}),
  }

  return (
    <JsonLd<Event>
      item={{
        "@context": "https://schema.org",
        "@type": "Event",
        name: event.name,
        eventAttendanceMode: "https://schema.org/OfflineEventAttendanceMode",
        eventStatus: "https://schema.org/EventScheduled",
        location: event.address,
        offers: {
          "@type": "Offer",
          availability: "https://schema.org/InStock",
          price: priceInterpolations.priceAmountForStructuredData,
          priceCurrency: city.currency,
          priceValidUntil: DateTime.now().plus({ years: 1 }).toISODate(),
          url: absolutePath,
        },
        ...optionalFields,
      }}
    />
  )
}
